import { getRequestConfig } from 'next-intl/server'

export const locales = ['en', 'fr', 'zh'] as const
export const defaultLocale = 'fr' as const

export default getRequestConfig(async ({ requestLocale }) => {
  const locale = await requestLocale

  const messages = {
    ...(await import(`../../messages/${locale}/address.json`)).default,
    ...(await import(`../../messages/${locale}/breadcrumb.json`)).default,
    ...(await import(`../../messages/${locale}/common.json`)).default,
    ...(await import(`../../messages/${locale}/drawers.json`)).default,
    ...(await import(`../../messages/${locale}/error.json`)).default,
    ...(await import(`../../messages/${locale}/formalities.json`)).default,
    ...(await import(`../../messages/${locale}/informations.json`)).default,
    ...(await import(`../../messages/${locale}/legal_status.json`)).default,
    ...(await import(`../../messages/${locale}/mails_options.json`)).default,
    ...(await import(`../../messages/${locale}/payment.json`)).default,
    ...(await import(`../../messages/${locale}/project.json`)).default,
    ...(await import(`../../messages/${locale}/society.json`)).default,
    ...(await import(`../../messages/${locale}/summary.json`)).default,
    ...(await import(`../../messages/${locale}/welcome.json`)).default
  }

  return { messages, locale }
})
